import * as React from 'react';
const SvgHeadless = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    width={800}
    height={800}
    viewBox='0 0 276.648 276.647'
    {...props}
  >
    <path
      fill={props.fill || 'black'}
      d='M67.964 0h18.158v55.987H67.964v-7.566H43.251V7.565h24.713V0zm75.593 173.759h58.729v-67.521c5.226 2.293 10.616 5.766 12.33 10.512 2.672 7.421-4.043 17.508-10.154 24.66l13.801 11.798c13.436-15.746 17.957-30.086 13.436-42.625-7.188-19.931-33.916-25.094-36.942-25.621l-10.628-1.841v.432l-.059-.213-11.213 75.282-11.153-78.297V77.94l-61.691-38.713-9.646 15.38 53.19 33.375v85.777zm58.73 15.421v-9.374h-58.729v20.415l22.13 17.366-32.778 58.854h56.031v-18.157h-25.132l16.349-29.348 17.862 14.009v33.703h18.158v-42.534l-27.083-21.249 13.192-23.685z'
    />
  </svg>
);
export default SvgHeadless;
